// extracted by mini-css-extract-plugin
export var MyKindoLogo = "MyKindoLogo-module--MyKindoLogo--12jVu";
export var my = "MyKindoLogo-module--my--2xID8";
export var kindo = "MyKindoLogo-module--kindo--2lvWi";